
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/laufaskolinn",
      function () {
        return require("private-next-pages/laufaskolinn.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/laufaskolinn"])
      });
    }
  